module.exports = __webpack_public_path__ + "static/media/htr4.acf26292.jpg";